export interface ItemCardStyle {
  cornerRadius?: number | null;
  borderWidth?: number | null;
  selectionBackgroundColor?: string | null;
}

export function buildItemCardCssRules(
  s: string,
  style: ItemCardStyle | null | undefined,
): string[] {
  if (!style) {
    return [];
  }

  const shapeProps: string[] = [];
  if (typeof style.cornerRadius === "number") {
    shapeProps.push(`border-radius: ${style.cornerRadius}px;`);
  }
  if (typeof style.borderWidth === "number") {
    shapeProps.push(`border-width: ${style.borderWidth}px;`);
  }
  const backgroundProp = style.selectionBackgroundColor
    ? `background-color: ${style.selectionBackgroundColor};`
    : undefined;
  if (shapeProps.length === 0 && backgroundProp === undefined) {
    return [];
  }

  const itemCardShapeRule =
    shapeProps.length > 0
      ? `${s}[data-ui="item-card"], ${s}[data-ui="address"] { ${shapeProps.join(" ")} }`
      : undefined;
  const itemCardBackgroundRule =
    backgroundProp !== undefined
      ? `${s}[data-ui="item-card"] { ${backgroundProp} }`
      : undefined;

  const radiusOnlyRule =
    typeof style.cornerRadius === "number"
      ? `${s}[data-ui="login-card"], ${s}[data-ui="summary"], ${s}[data-ui="redo-card"] { border-radius: ${style.cornerRadius}px; }`
      : undefined;

  // Generic bordered radio options keep all selection-card props on the same
  // element, so override them directly.
  const optionProps = [
    ...shapeProps,
    ...(backgroundProp ? [backgroundProp] : []),
  ].map((property) => property.replace(/;$/, " !important;"));
  const optionRule = `${s}[data-ui="option"], ${s}[data-ui="order-selection-option"] { ${optionProps.join(" ")} }`;

  // Checkbox-card-based option surfaces put the border on an outer wrapper, so
  // override radius/border-width there directly to match the radio options.
  const checkboxCardOuterRule = `${s}[data-selection-card] { ${optionProps.join(" ")} }`;

  return [
    itemCardShapeRule,
    itemCardBackgroundRule,
    radiusOnlyRule,
    optionRule,
    checkboxCardOuterRule,
  ].filter((rule): rule is string => rule !== undefined);
}
